module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-end-iStock-871227828.eec89730.jpg";